<template>
  <b-modal
    id="delete-saved-search-modal"
    ref="modal"
    :cancel-title="$t('Cancel')"
    :ok-title="$t('Delete')"
    centered
    hide-header
    ok-variant="danger"
    @cancel="hideModal"
    @close="hideModal"
    @ok="handleOk">

    <div class="delete-container">
      <div class="d-flex justify-content-between align-items-center mb-4">
      <span
        class="page-title"> {{
          $t('Delete') + ' ' + theArticle + (beginsWithVoyel ? '' : ' ') + $t(itemToString)
        }} </span>
        <i class="ph-custom ph-x-bold cursor" @click="hideModal"/>
      </div>

      <div v-if="selectedItem !== null " class="mb-4">
        {{ $t('Do.you.want.to.delete') }} {{ theArticle }}{{
          itemToString
        }}{{ " " + (selectedItemName ? `"${selectedItemName}"` : "") + ' ?' }}
      </div>
    </div>
  </b-modal>
</template>

<script>

import api from '../../services/api'

export default {

  name: 'DeleteSavedSearchModal',

  props: {
    selectedItem: Object,
    selectedItemName: String,
    itemToString: String,
    theArticle: String,
    beginsWithVoyel: Boolean,
  },

  emits: ['didDeleteItem'],

  methods: {

    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault() // Prevent modal from closing
      this.handleSubmit()
    },

    handleSubmit() {
      api
        .delete(`/savedSearch/${this.selectedItem}`)
        .then(response => {
          this.hideModal()
          this.$emit('didDeleteItem', this.selectedItem)
        })
        .catch((error) => {
          if (!error.response) {
            console.log("error", error);
          }
          if (error.response && (error.response.status === 401 || error.response.status === 404)) {
            this.$bvToast.toast(this.$i18n.t(error.response.data.message), {
              title: this.$i18n.t('Error.title'),
              autoHideDelay: 4000,
              toaster: 'b-toaster-bottom-right',
              solid: true
            });
          }
        })
    },

    hideModal() {
      this.$bvModal.hide('delete-saved-search-modal')
    },
  },

}
</script>

<style>
.cursor:hover {
  cursor: pointer;
}

/** pour éviter les 17px de padding qui s'ajoutent en responsive */
#delete-saved-search-modal {
  padding-left: 0px !important;
}

#delete-saved-search-modal .modal-content,
#delete-saved-search-modal .modal-header,
#delete-saved-search-modal .modal-body,
#delete-saved-search-modal .modal-footer {
  background-color: var(--main-black-dark) !important;
}

#delete-saved-search-modal .modal-header-content {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start !important;
  padding: 0;
  border-bottom: none;
}


#delete-saved-search-modal .modal-content {
  overflow: hidden;
  border-radius: 30px;
}


@media (max-width: 767px) {
  #delete-saved-search-modal .modal-content {
    display: flex;
    border-radius: 0px;
    overflow: auto;
  }

  #delete-saved-search-modal .modal-dialog {
    max-width: 100%;
    margin: 0;
  }

  #delete-saved-search-modal .modal-body {
    display: flex;
    justify-content: center;
    align-items: flex-start;
  }

  #delete-saved-search-modal .modal-dialog {
    max-width: 100%;
    margin: 0;
  }

  #delete-saved-search-modal .modal-content {
    padding: 0;
    border-radius: 0;
  }

  #delete-saved-search-modal .modal-header-content, .title-share-container {
    padding: 10px;
  }
}


#delete-saved-search-modal .btn-secondary {
  background-color: var(--main-black-dark) !important;
  border-color: var(--main-grey-light) !important;
  color: var(--main-white);
  border-radius: var(--main-border-radius);
  padding: 12px 20px;
  font-size: var(--content-font-size);
}

#delete-saved-search-modal .btn-secondary:hover:not([disabled]) {
  background-color: var(--main-black-medium) !important;
}


#delete-saved-search-modal .copy-clipboard {
  background-color: rgb(51, 51, 51);
}

</style>



// WEBPACK FOOTER //
// src/views/search/DeleteSavedSearchModal.vue